export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><g fill-rule=\"nonzero\"><path d=\"M10 2h2v12h-2z\" fill=\"#D7D8DE\"/><path d=\"M8.333 7.167H9v1.666h-.667z\" fill=\"#3F4450\"/><path d=\"M12.333 13.667V2A.333.333 0 0012 1.667h-1.667V1a.333.333 0 00-.388-.329l-6 1A.333.333 0 003.667 2v11.667h-3v.666h3.305l5.973.996a.333.333 0 00.388-.329v-.667h5v-.666zm-2.666.94l-5.334-.89V2.282l5.334-.889v13.213zm2-.94h-1.334V2.333h1.334z\" fill=\"#3F4450\"/></g></g>",
  "attrs": {
    "height": "16",
    "viewBox": "0 0 16 16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};